"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShiftedSubscriptionChargeDate = exports.SUBSCRIPTION_INTERVAL_IN_MONTHS = exports.getNextOccurrenceFromStartAndNextOccurrenceDates = exports.getNextOccurrenceWithThreeMonthGracePeriod = exports.getNextOccurrenceWithThreeMonthGracePeriodFromReferenceDate = exports.getNextOccurrenceFromReferenceDate = exports.getMonthDiff = exports.isDateSameDayDependingOnTimezone = exports.isDateSameDay = exports.isDateToday = exports.isDateAfterOneYear = exports.isDateInTheFuture = exports.isDateStrictlyInTheFuture = exports.isDateStrictlyInThePast = exports.isDayAndMonthInTheFuture = exports.getDateEndOfYear = exports.getDateStartOfYear = exports.getDateEndOfMonth = exports.getDateStartOfMonth = exports.getDateStartOfDay = exports.getUTCDateMidDay = exports.getDateMidDay = exports.getDateEndOfDay = exports.getDateNextYear = exports.getDateThisYear = exports.getDateLastYear = exports.getDateMinusNYears = exports.getDatePlusNYears = exports.getDateMinusNMonths = exports.getDatePlusNMonths = exports.getDateMinusNWeeks = exports.getDatePlusNWeeks = exports.getDateMinusNDays = exports.getDatePlusNDays = exports.getDateMinusNHours = exports.getDatePlusNHours = exports.getDateMinusNMinutes = exports.getDatePlusNMinutes = exports.getDateMinusNSeconds = exports.getDatePlusNSeconds = exports.getShortUtc = exports.shiftDatePreservingLocalTime = exports.luxonValidTimezones = exports.getTimezoneStrFromTimezone = exports.getTimezoneObject = exports.maxDate = exports.minDate = exports.browserDefaultTimezone = exports.isPostgresSafeIsoDate = exports.isIsoDateOnly = void 0;
exports.formatEventDates = exports.isInWeekendWindow = exports.getPreviousWeek = exports.isWeekComplete = exports.isWeekInFuture = exports.getWeekStartAndEndDates = exports.getCurrentWeek = exports.getCurrentDateFullName = exports.getUTCDateStartOfDay = exports.formatDateRange = exports.convertTimestampToCohort = exports.convertTimestampToDateNumber = exports.convertTimestampToDateString = exports.getDayBoundaries = exports.getWeekBoundaries = exports.getMonthBoundaries = exports.getYearBoundaries = exports.getJulyFirst10UTC = exports.getJanuaryFirst10UTC = exports.getYearListFromDate = exports.getMonthListFromDate = exports.formatDateToZeroUTCHours = exports.formatDateToTimestampZeroUTCHours = exports.setTimeToDate = exports.formatDateToLastMonth = exports.getFormatDateToTime = exports.getFormatDateToMinutes = exports.getFormatDateToHours = exports.getFormatDateToDayAndMonth = exports.formatDateToShortTime = exports.formatDateToShortDateTime = exports.formatDateToMediumDateTimeWithTimezone = exports.formatDateToMediumDateTime = exports.formatDateToFullDateTime = exports.formatDateToShortDate = exports.formatDateToMedDate = exports.formatDateToFullDate = exports.formatDateToRelative = exports.formatDateToIso = exports.formatDateToIsoStringInTimezone = exports.formatDateToIsoString = exports.formatDateOnly = exports.formatDateTimeToFormat = exports.formatTimeWithTimezone = exports.StartTicketEndTimePreset = exports.EndTicketEndTimePreset = exports.getDateTimestampInSeconds = exports.getDateTimestampInMilliseconds = exports.getLastOccurrence = exports.getProratedAmountAfterChargeDateShift = void 0;
exports.isMultiDayDate = exports.formatEventDateTime = void 0;
/* eslint-disable zeffy-linter/no-locale-condition -- legacy baseline (pre-rule); remove when these are migrated */
const countries_and_timezones_1 = require("countries-and-timezones");
const luxon_1 = require("luxon");
const locales_1 = require("../internationalization/enums/locales");
const dates_1 = require("../internationalization/features/dates");
const dates_2 = require("../internationalization/locales/dates");
const subscription_1 = require("../types/subscription");
const subscription_charge_day_1 = require("./subscription-charge-day");
const YYYY_MM_DD_FORMAT = "yyyy-MM-dd";
const isIsoDateOnly = (value) => typeof value === "string" &&
    /^\d{4}-\d{2}-\d{2}$/.test(value) &&
    !Number.isNaN(Date.parse(value)) &&
    new Date(value).toISOString().slice(0, 10) === value;
exports.isIsoDateOnly = isIsoDateOnly;
const isPostgresSafeIsoDate = (value) => (0, exports.isIsoDateOnly)(value) && value >= "0001-01-01";
exports.isPostgresSafeIsoDate = isPostgresSafeIsoDate;
exports.browserDefaultTimezone = luxon_1.DateTime.local().zoneName || "America/Montreal";
// arbitrary values chosen to handle most of the cases for our current time
exports.minDate = new Date(1900, 1, 1, 0, 0, 0, 0);
exports.maxDate = new Date(2100, 1, 1, 0, 0, 0, 0);
const invalidDateTimeString = "Invalid DateTime";
exports.getTimezoneObject = countries_and_timezones_1.getTimezone;
const getTimezoneStrFromTimezone = (timezoneName) => {
    const timezone = (0, countries_and_timezones_1.getTimezone)(timezoneName);
    if (!timezone) {
        return "";
    }
    if (timezone.utcOffsetStr === timezone.dstOffsetStr) {
        return `(GMT${timezone.utcOffsetStr}) ${timezoneName}`;
    }
    return `(GMT${timezone.utcOffsetStr} / GMT${timezone.dstOffsetStr}) ${timezoneName}`;
};
exports.getTimezoneStrFromTimezone = getTimezoneStrFromTimezone;
exports.luxonValidTimezones = Array.from(new Set(Object.keys((0, countries_and_timezones_1.getAllTimezones)())
    .filter((tz) => tz.includes("/") && luxon_1.DateTime.local().setZone(tz).isValid)
    .map((timezone) => ({ timezone, timezoneStr: (0, exports.getTimezoneStrFromTimezone)(timezone) })))).sort((a, b) => (a.timezoneStr < b.timezoneStr ? -1 : 1));
/**
 * Returns a new UTC instant such that its wall-clock representation in `toTimeZone`
 * matches the wall-clock representation of `date` in `fromTimeZone`.
 *
 * Example: if `date` represents "2025-12-25 18:00" in "America/New_York" and
 * `toTimeZone` is "Europe/Paris", the returned instant represents
 * "2025-12-25 18:00" in "Europe/Paris" (a different UTC instant).
 *
 * Used when the user changes a campaign's timezone and we want the set date/time
 * to stay visually identical instead of being reinterpreted in the new zone.
 */
const shiftDatePreservingLocalTime = (date, fromTimeZone, toTimeZone) => {
    if (!fromTimeZone || !toTimeZone || fromTimeZone === toTimeZone) {
        return date;
    }
    return luxon_1.DateTime.fromJSDate(date).setZone(fromTimeZone).setZone(toTimeZone, { keepLocalTime: true }).toJSDate();
};
exports.shiftDatePreservingLocalTime = shiftDatePreservingLocalTime;
const getShortUtc = (date, locale, timeZone) => {
    const formatter = new Intl.DateTimeFormat(locale, {
        hour: "2-digit",
        minute: "2-digit",
        timeZoneName: "short",
        timeZone: timeZone ?? undefined,
    });
    if (!formatter.formatToParts) {
        return "";
    }
    const formattedTime = formatter.formatToParts(new Date(date));
    return formattedTime.find((formattedPart) => formattedPart.type === "timeZoneName")?.value || "";
};
exports.getShortUtc = getShortUtc;
const getDatePlusNSeconds = (date, seconds) => (0, dates_1.getDateTime)(date).plus({ seconds }).toJSDate();
exports.getDatePlusNSeconds = getDatePlusNSeconds;
const getDateMinusNSeconds = (date, seconds) => (0, dates_1.getDateTime)(date).minus({ seconds }).toJSDate();
exports.getDateMinusNSeconds = getDateMinusNSeconds;
const getDatePlusNMinutes = (date, minutes) => (0, dates_1.getDateTime)(date).plus({ minutes }).toJSDate();
exports.getDatePlusNMinutes = getDatePlusNMinutes;
const getDateMinusNMinutes = (date, minutes) => (0, dates_1.getDateTime)(date).minus({ minutes }).toJSDate();
exports.getDateMinusNMinutes = getDateMinusNMinutes;
const getDatePlusNHours = (date, hours) => (0, dates_1.getDateTime)(date).plus({ hours }).toJSDate();
exports.getDatePlusNHours = getDatePlusNHours;
const getDateMinusNHours = (date, hours) => (0, dates_1.getDateTime)(date).minus({ hours }).toJSDate();
exports.getDateMinusNHours = getDateMinusNHours;
const getDatePlusNDays = (date, days) => (0, dates_1.getDateTime)(date).plus({ days }).toJSDate();
exports.getDatePlusNDays = getDatePlusNDays;
const getDateMinusNDays = (date, days) => (0, dates_1.getDateTime)(date).minus({ days }).toJSDate();
exports.getDateMinusNDays = getDateMinusNDays;
const getDatePlusNWeeks = (date, weeks) => (0, dates_1.getDateTime)(date).plus({ weeks }).toJSDate();
exports.getDatePlusNWeeks = getDatePlusNWeeks;
const getDateMinusNWeeks = (date, weeks) => (0, dates_1.getDateTime)(date).minus({ weeks }).toJSDate();
exports.getDateMinusNWeeks = getDateMinusNWeeks;
const getDatePlusNMonths = (date, months) => (0, dates_1.getDateTime)(date).plus({ months }).toJSDate();
exports.getDatePlusNMonths = getDatePlusNMonths;
const getDateMinusNMonths = (date, months) => (0, dates_1.getDateTime)(date).minus({ months }).toJSDate();
exports.getDateMinusNMonths = getDateMinusNMonths;
const getDatePlusNYears = (date, years) => (0, dates_1.getDateTime)(date).plus({ years }).toJSDate();
exports.getDatePlusNYears = getDatePlusNYears;
const getDateMinusNYears = (date, years) => (0, dates_1.getDateTime)(date).minus({ years }).toJSDate();
exports.getDateMinusNYears = getDateMinusNYears;
const getDateLastYear = (date) => new Date(new Date(date).setFullYear(new Date().getFullYear() - 1));
exports.getDateLastYear = getDateLastYear;
const getDateThisYear = (date) => new Date(new Date(date).setFullYear(new Date().getFullYear()));
exports.getDateThisYear = getDateThisYear;
const getDateNextYear = (date) => new Date(new Date(date).setFullYear(new Date().getFullYear() + 1));
exports.getDateNextYear = getDateNextYear;
const getDateEndOfDay = (date) => (0, dates_1.getDateTime)(date).endOf("day").toJSDate();
exports.getDateEndOfDay = getDateEndOfDay;
const getDateMidDay = (date) => new Date(new Date(date).setHours(12, 0, 0, 0));
exports.getDateMidDay = getDateMidDay;
const getUTCDateMidDay = (date) => {
    const d = new Date(date);
    d.setUTCHours(12, 0, 0, 0);
    return d;
};
exports.getUTCDateMidDay = getUTCDateMidDay;
const getDateStartOfDay = (date) => (0, dates_1.getDateTime)(date).startOf("day").toJSDate();
exports.getDateStartOfDay = getDateStartOfDay;
const getDateStartOfMonth = (date) => (0, dates_1.getDateTime)(date).startOf("month").toJSDate();
exports.getDateStartOfMonth = getDateStartOfMonth;
const getDateEndOfMonth = (date) => (0, dates_1.getDateTime)(date).endOf("month").toJSDate();
exports.getDateEndOfMonth = getDateEndOfMonth;
const getDateStartOfYear = (date) => (0, dates_1.getDateTime)(date).startOf("year").toJSDate();
exports.getDateStartOfYear = getDateStartOfYear;
const getDateEndOfYear = (date) => (0, dates_1.getDateTime)(date).endOf("year").toJSDate();
exports.getDateEndOfYear = getDateEndOfYear;
const isDayAndMonthInTheFuture = (date) => {
    const now = new Date();
    const currentDay = now.getDate();
    const currentMonth = now.getMonth();
    const dayOfDate = new Date(date).getDate();
    const monthOfDate = new Date(date).getMonth();
    return monthOfDate > currentMonth || (monthOfDate === currentMonth && dayOfDate > currentDay);
};
exports.isDayAndMonthInTheFuture = isDayAndMonthInTheFuture;
const isDateStrictlyInThePast = (date) => {
    const now = (0, dates_1.getDateTime)(new Date());
    return (0, dates_1.getDateTime)(date).startOf("day") < now.startOf("day");
};
exports.isDateStrictlyInThePast = isDateStrictlyInThePast;
const isDateStrictlyInTheFuture = (date) => {
    const now = (0, dates_1.getDateTime)(new Date());
    return (0, dates_1.getDateTime)(date).startOf("day") > now.startOf("day");
};
exports.isDateStrictlyInTheFuture = isDateStrictlyInTheFuture;
const isDateInTheFuture = (date) => !(0, exports.isDateStrictlyInThePast)(date);
exports.isDateInTheFuture = isDateInTheFuture;
const isDateAfterOneYear = (date) => {
    const nowPlusOneYear = (0, dates_1.getDateTime)((0, exports.getDatePlusNYears)(new Date(), 1));
    return (0, dates_1.getDateTime)(date).startOf("day") > nowPlusOneYear.startOf("day");
};
exports.isDateAfterOneYear = isDateAfterOneYear;
const isDateToday = (date) => (0, exports.isDateSameDay)(date, new Date());
exports.isDateToday = isDateToday;
const isDateSameDay = (date1, date2) => {
    const dateTime1 = (0, dates_1.getDateTime)(date1);
    const dateTime2 = (0, dates_1.getDateTime)(date2);
    return (dateTime1.hasSame(dateTime2, "year") && dateTime1.hasSame(dateTime2, "month") && dateTime1.hasSame(dateTime2, "day"));
};
exports.isDateSameDay = isDateSameDay;
const isDateSameDayDependingOnTimezone = (startUtc, endUtc, isoLocale, eventTimezone) => {
    if (!startUtc || !endUtc) {
        return false;
    }
    const options = {
        timeZone: eventTimezone,
        year: "numeric",
        month: "numeric",
        day: "numeric",
    };
    const formatter = new Intl.DateTimeFormat(isoLocale, options);
    const startDateString = formatter.format(startUtc);
    const endDateString = formatter.format(endUtc);
    return startDateString === endDateString;
};
exports.isDateSameDayDependingOnTimezone = isDateSameDayDependingOnTimezone;
const getMonthDiff = (date1, date2) => {
    const dateTime1 = (0, dates_1.getDateTime)(date1);
    const dateTime2 = (0, dates_1.getDateTime)(date2);
    return dateTime2.diff(dateTime1, "months").toObject().months || 0;
};
exports.getMonthDiff = getMonthDiff;
const isDayAndMonthAfterReference = (date, referenceDate) => {
    const reference = new Date(referenceDate);
    const target = new Date(date);
    const referenceMonth = reference.getMonth();
    const referenceDay = reference.getDate();
    const targetMonth = target.getMonth();
    const targetDay = target.getDate();
    return targetMonth > referenceMonth || (targetMonth === referenceMonth && targetDay > referenceDay);
};
const getNextOccurrenceFromReferenceDate = (date, referenceDate) => {
    const referenceYear = new Date(referenceDate).getFullYear();
    const targetYear = isDayAndMonthAfterReference(date, referenceDate) ? referenceYear : referenceYear + 1;
    return new Date(new Date(date).setFullYear(targetYear));
};
exports.getNextOccurrenceFromReferenceDate = getNextOccurrenceFromReferenceDate;
const getNextOccurrenceWithThreeMonthGracePeriodFromReferenceDate = (date, referenceDate) => {
    const dateMidDay = (0, exports.getDateMidDay)(date);
    const nextOccurrence = (0, exports.getNextOccurrenceFromReferenceDate)(dateMidDay, referenceDate);
    const monthDiff = (0, exports.getMonthDiff)((0, exports.getDateMidDay)(referenceDate), nextOccurrence);
    return monthDiff > 3 ? nextOccurrence : (0, exports.getDatePlusNYears)(nextOccurrence, 1);
};
exports.getNextOccurrenceWithThreeMonthGracePeriodFromReferenceDate = getNextOccurrenceWithThreeMonthGracePeriodFromReferenceDate;
const getNextOccurrenceWithThreeMonthGracePeriod = (date) => (0, exports.getNextOccurrenceWithThreeMonthGracePeriodFromReferenceDate)(date, new Date());
exports.getNextOccurrenceWithThreeMonthGracePeriod = getNextOccurrenceWithThreeMonthGracePeriod;
const getNextOccurrenceFromStartAndNextOccurrenceDates = (startDate, nextOccurrenceDate) => {
    if (!startDate) {
        return nextOccurrenceDate;
    }
    const startMidDate = (0, exports.getDateMidDay)(startDate);
    const monthDiff = (0, exports.getMonthDiff)(startMidDate, nextOccurrenceDate);
    // Next occurrence should always be at most 15 months away
    if (monthDiff <= 15) {
        return nextOccurrenceDate;
    }
    const startMidDateTime = (0, dates_1.getDateTime)(startMidDate);
    const endDateTime = (0, dates_1.getDateTime)(nextOccurrenceDate);
    const adjustedNextOccurrenceDate = startMidDateTime.set({
        year: startMidDateTime.year + 1,
        month: endDateTime.month,
        day: endDateTime.day,
    });
    // If that's still too far, use the year before
    if ((0, exports.getMonthDiff)(startMidDate, adjustedNextOccurrenceDate.toJSDate()) > 15) {
        return startMidDateTime
            .set({
            year: startMidDateTime.year,
            month: endDateTime.month,
            day: endDateTime.day,
        })
            .toJSDate();
    }
    return adjustedNextOccurrenceDate.toJSDate();
};
exports.getNextOccurrenceFromStartAndNextOccurrenceDates = getNextOccurrenceFromStartAndNextOccurrenceDates;
exports.SUBSCRIPTION_INTERVAL_IN_MONTHS = {
    [subscription_1.SubscriptionRecurrenceInterval.Monthly]: 1,
    [subscription_1.SubscriptionRecurrenceInterval.Quarterly]: 3,
    [subscription_1.SubscriptionRecurrenceInterval.Yearly]: 12,
};
const onChargeDayOfMonth = (month, day) => {
    const local = month.set({ day: day === "last" ? (0, subscription_charge_day_1.getDaysInMonth)(month) : Math.min(day, (0, subscription_charge_day_1.getDaysInMonth)(month)) });
    return day === "last" ? (0, subscription_charge_day_1.atLastDayOfMonthChargeHour)(local) : (0, subscription_charge_day_1.offLastDayOfMonthChargeHour)(local);
};
const getShiftedSubscriptionChargeDate = ({ currentNextChargeDate, day, month, recurrenceInterval, timezone, now = new Date(), }) => {
    const intervalInMonths = exports.SUBSCRIPTION_INTERVAL_IN_MONTHS[recurrenceInterval];
    const scheduled = (0, subscription_charge_day_1.toChargeTimezoneDateTime)(new Date(currentNextChargeDate), timezone);
    const firstOfMonth = scheduled.set({ day: 1, ...(month !== undefined ? { month } : {}) });
    const monthsAfter = (count) => firstOfMonth.plus({ months: intervalInMonths * count });
    const chargeAfter = (count) => onChargeDayOfMonth(monthsAfter(count), day);
    const firstFutureCount = (count) => chargeAfter(count).toMillis() <= now.getTime() ? firstFutureCount(count + 1) : count;
    const count = firstFutureCount(0);
    const shifted = chargeAfter(count);
    if (month !== undefined && shifted.toMillis() > scheduled.toMillis()) {
        const previous = chargeAfter(count - 1);
        if (previous.toMillis() > now.getTime()) {
            return previous.toJSDate();
        }
    }
    return shifted.toJSDate();
};
exports.getShiftedSubscriptionChargeDate = getShiftedSubscriptionChargeDate;
const getProratedAmountAfterChargeDateShift = ({ currentNextChargeDate, newChargeDate, recurrenceInterval, amount, }) => {
    const paidThrough = luxon_1.DateTime.fromJSDate(new Date(currentNextChargeDate), { zone: "utc" });
    const shifted = luxon_1.DateTime.fromJSDate(new Date(newChargeDate), { zone: "utc" });
    if (shifted >= paidThrough) {
        return null;
    }
    const paidPeriodStart = paidThrough.minus(subscription_charge_day_1.SUBSCRIPTION_PERIOD[recurrenceInterval]);
    const unusedRatio = paidThrough.diff(shifted).as("milliseconds") / paidThrough.diff(paidPeriodStart).as("milliseconds");
    return Math.max(amount - Math.round(amount * unusedRatio), 0);
};
exports.getProratedAmountAfterChargeDateShift = getProratedAmountAfterChargeDateShift;
const getLastOccurrence = (date) => (0, exports.isDayAndMonthInTheFuture)(date) ? (0, exports.getDateLastYear)(date) : (0, exports.getDateThisYear)(date);
exports.getLastOccurrence = getLastOccurrence;
const getDateTimestampInMilliseconds = (date) => new Date(date).getTime();
exports.getDateTimestampInMilliseconds = getDateTimestampInMilliseconds;
const getDateTimestampInSeconds = (date) => Math.floor((0, exports.getDateTimestampInMilliseconds)(new Date(date)) / 1000);
exports.getDateTimestampInSeconds = getDateTimestampInSeconds;
exports.EndTicketEndTimePreset = {
    hour: "numeric",
    minute: "2-digit",
    timeZoneName: "short",
};
exports.StartTicketEndTimePreset = {
    hour: "numeric",
    minute: "2-digit",
};
const formatTimeWithTimezone = (date, locale, timeZone) => {
    return (0, dates_1.formatDateTimeToLocaleString)(date, locale, exports.EndTicketEndTimePreset, timeZone);
};
exports.formatTimeWithTimezone = formatTimeWithTimezone;
const formatDateTimeToFormat = (date, locale, format, timeZone) => timeZone
    ? (0, dates_1.getDateTime)(date).setLocale(locale.toLowerCase()).setZone(timeZone).toFormat(format)
    : (0, dates_1.getDateTime)(date).setLocale(locale.toLowerCase()).toFormat(format);
exports.formatDateTimeToFormat = formatDateTimeToFormat;
const formatDateOnly = (date, locale, format) => {
    const dateTime = (0, dates_1.getDateTime)(date, { zone: "utc" }).setLocale(locale.toLowerCase());
    return typeof format === "string" ? dateTime.toFormat(format) : dateTime.toLocaleString(format);
};
exports.formatDateOnly = formatDateOnly;
const formatDateToIsoString = (date) => (0, dates_1.getDateTime)(date).toISODate() || invalidDateTimeString;
exports.formatDateToIsoString = formatDateToIsoString;
/**
 * Converts a UTC date to ISO date string (YYYY-MM-DD) in the specified timezone.
 * This is useful for getting the local date for a user in a specific timezone.
 * For example, a transaction at 4 AM UTC would be 11 PM EST the previous day.
 *
 * @param date - The UTC date to convert
 * @param timeZone - The IANA timezone (e.g., 'America/New_York', 'Europe/Paris')
 * @returns ISO date string in the specified timezone (YYYY-MM-DD)
 */
const formatDateToIsoStringInTimezone = (date, timeZone) => (0, dates_1.getDateTime)(date).setZone(timeZone).toISODate() || invalidDateTimeString;
exports.formatDateToIsoStringInTimezone = formatDateToIsoStringInTimezone;
const formatDateToIso = (date, options) => (0, dates_1.getDateTime)(date).toISO(options) || invalidDateTimeString;
exports.formatDateToIso = formatDateToIso;
const formatDateToRelative = (date, locale) => (0, dates_1.getDateTime)(date).setLocale(locale.toLowerCase()).toRelative();
exports.formatDateToRelative = formatDateToRelative;
/**
 * @param date
 * @param locale
 * @returns format like 'April 25, 2022'
 */
const formatDateToFullDate = (date, locale, timeZone) => (0, dates_1.formatDateTimeToLocaleString)(date, locale, luxon_1.DateTime.DATE_FULL, timeZone);
exports.formatDateToFullDate = formatDateToFullDate;
/**
 * @param date
 * @param locale
 * @returns format like 'Apr 25, 2022'
 */
const formatDateToMedDate = (date, locale, timeZone) => (0, dates_1.formatDateTimeToLocaleString)(date, locale, luxon_1.DateTime.DATE_MED, timeZone);
exports.formatDateToMedDate = formatDateToMedDate;
/**
 * @param date
 * @param locale
 * @returns format like 25/04/2022
 */
const formatDateToShortDate = (date, locale, timeZone) => (0, dates_1.formatDateTimeToLocaleString)(date, locale, luxon_1.DateTime.DATE_SHORT, timeZone);
exports.formatDateToShortDate = formatDateToShortDate;
/**
 * @param date
 * @param locale
 * @returns format like 'April 25, 2022, 9:30 AM EDT'
 */
const formatDateToFullDateTime = (date, locale) => (0, dates_1.formatDateTimeToLocaleString)(date, locale, luxon_1.DateTime.DATETIME_FULL);
exports.formatDateToFullDateTime = formatDateToFullDateTime;
/**
 * @param date
 * @param locale
 * @returns format like 'Apr 25, 2022, 9:30 AM'
 */
const formatDateToMediumDateTime = (date, locale, timeZone) => (0, dates_1.formatDateTimeToLocaleString)(date, locale, luxon_1.DateTime.DATETIME_MED, timeZone);
exports.formatDateToMediumDateTime = formatDateToMediumDateTime;
/**
 * @param date
 * @param locale
 * @returns format like 'Apr 25, 2022, 9:30 AM EDT' (medium date/time with the timezone abbreviation)
 */
const formatDateToMediumDateTimeWithTimezone = (date, locale, timeZone) => (0, dates_1.formatDateTimeToLocaleString)(date, locale, { ...luxon_1.DateTime.DATETIME_MED, timeZoneName: "short" }, timeZone);
exports.formatDateToMediumDateTimeWithTimezone = formatDateToMediumDateTimeWithTimezone;
/**
 * @param date
 * @param locale
 * @returns format like '25/04/2022, 9:30 AM'
 */
const formatDateToShortDateTime = (date, locale, timeZone) => (0, dates_1.formatDateTimeToLocaleString)(date, locale, luxon_1.DateTime.DATETIME_SHORT, timeZone);
exports.formatDateToShortDateTime = formatDateToShortDateTime;
/**
 * @param date
 * @param locale
 * @returns format like '9:30 AM'
 */
const formatDateToShortTime = (date, locale, timeZone) => (0, dates_1.formatDateTimeToLocaleString)(date, locale, luxon_1.DateTime.TIME_SIMPLE, timeZone);
exports.formatDateToShortTime = formatDateToShortTime;
const getFormatDateToDayAndMonth = (locale) => {
    switch (locale) {
        case locales_1.Locales.EN:
            return "LLL d";
        case locales_1.Locales.FR:
            return "d LLL";
        default:
            return "dd/LL";
    }
};
exports.getFormatDateToDayAndMonth = getFormatDateToDayAndMonth;
const getFormatDateToHours = () => "HH";
exports.getFormatDateToHours = getFormatDateToHours;
const getFormatDateToMinutes = () => "mm";
exports.getFormatDateToMinutes = getFormatDateToMinutes;
const getFormatDateToTime = () => "HH:mm";
exports.getFormatDateToTime = getFormatDateToTime;
const formatDateToLastMonth = (date, locale) => {
    return dates_2.MONTH_NAMES[locale][((0, dates_1.getDateTime)(date).month + 10) % 12];
};
exports.formatDateToLastMonth = formatDateToLastMonth;
const setTimeToDate = (date, time) => {
    const robustTime = new Date(time);
    return new Date(new Date(date).setHours(robustTime.getHours(), robustTime.getMinutes(), 0, 0));
};
exports.setTimeToDate = setTimeToDate;
const formatDateToTimestampZeroUTCHours = (date) => {
    const date1 = new Date(date);
    date1.setUTCHours(0, 0, 0, 0);
    return Date.parse(date1.toString());
};
exports.formatDateToTimestampZeroUTCHours = formatDateToTimestampZeroUTCHours;
const formatDateToZeroUTCHours = (date) => {
    return new Date(date).setUTCHours(0, 0, 0, 0);
};
exports.formatDateToZeroUTCHours = formatDateToZeroUTCHours;
const getMonthListFromDate = (date) => {
    let i = new Date(new Date(date).getFullYear(), new Date(date).getMonth(), 1, 0, 0, 1).getTime();
    const now = Date.now();
    if (i > now) {
        return [];
    }
    const monthList = [];
    while (i < now) {
        monthList.push(new Date(i).setDate(1));
        i = (0, exports.getDatePlusNMonths)(new Date(i), 1).getTime();
    }
    return monthList.map((timestamps) => {
        const date = new Date(timestamps);
        return {
            month: date.getMonth(),
            year: date.getFullYear(),
        };
    });
};
exports.getMonthListFromDate = getMonthListFromDate;
const getYearListFromDate = (date) => {
    if (new Date(date).getTime() >= Date.now()) {
        return [];
    }
    const yearList = [];
    let i = new Date(date).getFullYear();
    const now = new Date().getFullYear();
    while (i <= now) {
        yearList.push(i);
        i++;
    }
    return yearList;
};
exports.getYearListFromDate = getYearListFromDate;
const getJanuaryFirst10UTC = (year) => {
    return new Date(Date.UTC(year, 0, 1, 10, 0, 0));
};
exports.getJanuaryFirst10UTC = getJanuaryFirst10UTC;
const getJulyFirst10UTC = (year) => {
    return new Date(Date.UTC(year, 6, 1, 10, 0, 0));
};
exports.getJulyFirst10UTC = getJulyFirst10UTC;
const getYearBoundaries = (year) => {
    const startDate = new Date(Date.UTC(year, 0, 1));
    const endDate = new Date(Date.UTC(year + 1, 0, 1));
    return [startDate, endDate];
};
exports.getYearBoundaries = getYearBoundaries;
const getMonthBoundaries = (month, year) => {
    const startDate = new Date(year, month, 1);
    const endDate = new Date(year, month + 1, 1);
    return [startDate, endDate];
};
exports.getMonthBoundaries = getMonthBoundaries;
const getWeekBoundaries = (date) => {
    const startDate = (0, dates_1.getDateTime)(date).startOf("week").toJSDate();
    const endDate = (0, dates_1.getDateTime)(date).endOf("week").toJSDate();
    return [startDate, endDate];
};
exports.getWeekBoundaries = getWeekBoundaries;
const getDayBoundaries = (date) => {
    const startDate = (0, exports.getDateStartOfDay)(date);
    const endDate = (0, exports.getDateEndOfDay)(date);
    return [startDate, endDate];
};
exports.getDayBoundaries = getDayBoundaries;
/**
 *
 * @param timestamp
 * @returns A date string in the format 'YYYY-MM-DD'
 */
const convertTimestampToDateString = (timestamp) => {
    const luxonDate = luxon_1.DateTime.fromJSDate(timestamp instanceof Date ? timestamp : new Date(timestamp));
    return luxonDate.toFormat(YYYY_MM_DD_FORMAT);
};
exports.convertTimestampToDateString = convertTimestampToDateString;
/**
 *
 * @param timestamp
 * @returns A date number in the format 'YYYYMMDD'
 */
const convertTimestampToDateNumber = (timestamp) => {
    const luxonDate = luxon_1.DateTime.fromJSDate(timestamp instanceof Date ? timestamp : new Date(timestamp));
    return Number(luxonDate.toFormat("yyyyMMdd"));
};
exports.convertTimestampToDateNumber = convertTimestampToDateNumber;
const convertTimestampToCohort = (timestamp) => {
    const luxonDate = luxon_1.DateTime.fromJSDate(timestamp instanceof Date ? timestamp : new Date(timestamp));
    // Monday
    const firstDayOfWeek = luxonDate.startOf("week");
    const firstDayFormatted = firstDayOfWeek.toFormat(YYYY_MM_DD_FORMAT);
    // Sunday
    const lastDayOfWeek = luxonDate.endOf("week");
    const lastDayFormatted = lastDayOfWeek.toFormat(YYYY_MM_DD_FORMAT);
    return `${firstDayFormatted} to ${lastDayFormatted}`;
};
exports.convertTimestampToCohort = convertTimestampToCohort;
/**
 * @param startDate
 * @param endDate
 * @param locale
 * @returns format like 'October 1 - 24, 2023' if they have the same month and year
 * @returns format like 'Sep 1 - Sep 30, 2023' if they have the same year but a different month
 * @returns format like 'Sep 1, 2022 - Sep 30, 2023' if they have different years
 */
const formatDateRange = (startDate, endDate, locale) => {
    if (!startDate || !endDate) {
        return "";
    }
    const parsedStartDate = (0, dates_1.getDateTime)(startDate).setLocale(locale.toLowerCase());
    const parsedEndDate = (0, dates_1.getDateTime)(endDate).setLocale(locale.toLowerCase());
    const hasSameMonth = parsedStartDate.month === parsedEndDate.month;
    const hasSameYear = parsedStartDate.year === parsedEndDate.year;
    if (!hasSameYear) {
        return `${parsedStartDate.monthShort} ${parsedStartDate.day}, ${parsedStartDate.year} - ${parsedStartDate.monthShort} ${parsedEndDate.day}, ${parsedEndDate.year}`;
    }
    else if (!hasSameMonth) {
        return `${parsedStartDate.monthShort} ${parsedStartDate.day} - ${parsedEndDate.monthShort} ${parsedEndDate.day}, ${parsedEndDate.year}`;
    }
    else {
        return `${parsedStartDate.monthShort} ${parsedStartDate.day} - ${parsedEndDate.day}, ${parsedEndDate.year}`;
    }
};
exports.formatDateRange = formatDateRange;
const getUTCDateStartOfDay = (date) => (0, dates_1.getDateTime)((0, exports.getDateMidDay)(date)).setZone("utc").startOf("day").toJSDate();
exports.getUTCDateStartOfDay = getUTCDateStartOfDay;
const getCurrentDateFullName = (locale) => (0, dates_1.getDateTime)(new Date()).setLocale(locale).toFormat("LLLL");
exports.getCurrentDateFullName = getCurrentDateFullName;
const getCurrentWeek = (date) => {
    const dt = date ? luxon_1.DateTime.fromJSDate(date) : luxon_1.DateTime.now();
    const weekNumber = dt.weekNumber;
    const weekYear = dt.weekYear;
    return {
        week: weekNumber,
        year: weekYear,
    };
};
exports.getCurrentWeek = getCurrentWeek;
const getWeekStartAndEndDates = ({ week, year }) => {
    const startOfWeekLuxon = luxon_1.DateTime.fromObject({
        weekYear: year,
        weekNumber: week,
        // weekday: 1 // Explicitly setting Monday (1) is optional, as it's the default for fromObject with week info
    }, { zone: "utc" } // Use UTC to avoid timezone shifts affecting the date boundaries
    );
    // Calculate the end of the week (Sunday)
    // endOf('week') sets it to Sunday 23:59:59.999 in the specified zone (UTC here)
    const endOfWeekLuxon = startOfWeekLuxon.endOf("week");
    // Convert the Luxon DateTime objects back to standard JavaScript Date objects
    const startDateJS = startOfWeekLuxon.toJSDate();
    const endDateJS = endOfWeekLuxon.toJSDate();
    return {
        startDate: startDateJS,
        endDate: endDateJS,
    };
};
exports.getWeekStartAndEndDates = getWeekStartAndEndDates;
/**
 * Checks if a given week is in the future compared to the current date
 *
 * @param weekData Object containing week number (1-53) and year
 * @returns boolean - true if the week is in the future, false otherwise
 */
const isWeekInFuture = (weekData) => {
    const { week, year } = weekData;
    // Validate inputs
    if (week < 1 || week > 53) {
        throw new Error("Week must be between 1 and 53");
    }
    // Get current week and year using the existing function
    const currentWeekData = (0, exports.getCurrentWeek)();
    const { week: currentWeek, year: currentYear } = currentWeekData;
    // If the year is in the future, the week is definitely in the future
    if (year > currentYear) {
        return true;
    }
    // If the year is in the past, the week is definitely in the past
    if (year < currentYear) {
        return false;
    }
    // If we're in the same year, compare week numbers
    return week > currentWeek;
};
exports.isWeekInFuture = isWeekInFuture;
const isWeekComplete = (weekData) => {
    // Get the end date of the week
    const { endDate } = (0, exports.getWeekStartAndEndDates)(weekData);
    // Get the current date (at the start of the day to avoid time comparison issues)
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    // The week is complete if its end date is before today
    return endDate < today;
};
exports.isWeekComplete = isWeekComplete;
/**
 * Gets the previous week
 *
 * @returns NumericalWeek - The week number and year of the previous week
 */
const getPreviousWeek = () => {
    // Get the current date
    const today = new Date();
    // Create a new date that's 7 days ago
    const lastWeekDate = new Date(today);
    lastWeekDate.setDate(today.getDate() - 7);
    // Get the week and year for that date
    return (0, exports.getCurrentWeek)(lastWeekDate);
};
exports.getPreviousWeek = getPreviousWeek;
/**
 * Checks if the current time is within the weekend window
 * Weekend window is defined as Friday 8 AM CET to Sunday 8 AM CET
 *
 * @returns boolean - true if within weekend window, false otherwise
 */
const isInWeekendWindow = () => {
    const now = luxon_1.DateTime.now().setZone("Europe/Paris");
    const dayOfWeek = now.weekday; // 1 = Monday, 5 = Friday, 7 = Sunday
    const hour = now.hour;
    // Friday 8 AM CET to Sunday 8 AM CET
    return (dayOfWeek === 5 && hour >= 8) || dayOfWeek === 6 || (dayOfWeek === 7 && hour < 8);
};
exports.isInWeekendWindow = isInWeekendWindow;
const formatEventDates = (dates, timezone, options) => {
    if (dates.length === 0) {
        return { formattedDate: "" };
    }
    const { locale, showYear, showOnlyEndDate } = options ?? {};
    const formatOpts = locale ? { locale } : undefined;
    const datePrefix = showYear ? "MMM d, yyyy" : "MMM d";
    const toDateTime = (date) => {
        let dt = luxon_1.DateTime.fromJSDate(date);
        if (timezone) {
            dt = dt.setZone(timezone);
        }
        return dt;
    };
    if (showOnlyEndDate) {
        const latestEnd = toDateTime([...dates].sort((a, b) => b.endUtc.getTime() - a.endUtc.getTime())[0].endUtc);
        return { formattedDate: latestEnd.toFormat(datePrefix + ", h:mm a ZZZZ", formatOpts) };
    }
    if (dates.length === 1) {
        const startDate = toDateTime(dates[0].startUtc);
        const endDate = toDateTime(dates[0].endUtc);
        if (startDate.hasSame(endDate, "day")) {
            const startFormatted = startDate.toFormat(datePrefix + ", h:mm", formatOpts);
            const endFormatted = endDate.toFormat("h:mm a ZZZZ", formatOpts);
            return { formattedDate: startFormatted + " - " + endFormatted };
        }
        const startFormatted = startDate.toFormat(datePrefix + ", h:mm a", formatOpts);
        const endFormatted = endDate.toFormat(datePrefix + ", h:mm a ZZZZ", formatOpts);
        return { formattedDate: startFormatted + " - " + endFormatted };
    }
    const sortedDates = [...dates].sort((a, b) => a.startUtc.getTime() - b.startUtc.getTime());
    const earliestStart = toDateTime(sortedDates[0].startUtc);
    const latestEnd = toDateTime([...dates].sort((a, b) => b.endUtc.getTime() - a.endUtc.getTime())[0].endUtc);
    const startFormatted = earliestStart.toFormat(datePrefix, formatOpts);
    const endFormatted = latestEnd.toFormat(datePrefix, formatOpts);
    return { formattedDate: startFormatted + " - " + endFormatted };
};
exports.formatEventDates = formatEventDates;
const formatEventDateTime = (startUtc, endUtc, locale) => {
    if (!startUtc || !endUtc) {
        return "";
    }
    const startDate = (0, dates_1.getDateTime)(startUtc).setLocale(locale.toLowerCase());
    const endDate = (0, dates_1.getDateTime)(endUtc).setLocale(locale.toLowerCase());
    const startDateStr = startDate.toFormat("MMM d");
    const startTimeStr = startDate.toFormat("h:mm a").toLowerCase();
    const endDateStr = endDate.toFormat("MMM d");
    const endTimeStr = endDate.toFormat("h:mm a").toLowerCase();
    if (startDate.hasSame(endDate, "day")) {
        return `${startDateStr}, ${startTimeStr} - ${endTimeStr}`;
    }
    return `${startDateStr}, ${startTimeStr} - ${endDateStr}, ${endTimeStr}`;
};
exports.formatEventDateTime = formatEventDateTime;
const isMultiDayDate = (luxonStartDate, luxonEndDate) => {
    const isSameDay = luxonStartDate.startOf("day").equals(luxonEndDate.startOf("day"));
    const nextDay = luxonStartDate.plus({ days: 1 }).startOf("day");
    return !isSameDay && !(luxonStartDate.hour >= 17 && luxonEndDate < nextDay.plus({ hours: 7 }));
};
exports.isMultiDayDate = isMultiDayDate;
